import { StyleSheet, Platform } from 'react-native'

export const landingCtaBandStyles = StyleSheet.create({
  section: {
    paddingHorizontal: 24,
    paddingVertical: 48,
  },
  sectionPhone: {
    paddingHorizontal: 16,
    paddingVertical: 34,
  },
  contactCard: {
    maxWidth: 1720,
    marginHorizontal: 'auto' as unknown as number,
    width: '100%',
    backgroundColor: '#1A202C',
    borderRadius: 28,
    padding: Platform.OS === 'web' ? 54 : 30,
    flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 36,
  },
  contactCardStacked: {
    flexDirection: 'column',
  },
  contactCardPhone: {
    borderRadius: 22,
    padding: 18,
    gap: 24,
  },
  copy: {
    flex: Platform.OS === 'web' ? 0.9 : undefined,
    maxWidth: 520,
  },
  copyStacked: {
    flex: 0,
    maxWidth: 680,
    width: '100%',
  },
  copyPhone: {
    maxWidth: '100%' as unknown as number,
    width: '100%',
  },
  formWrap: {
    flex: Platform.OS === 'web' ? 1.1 : undefined,
    width: '100%',
    backgroundColor: '#111827',
    borderWidth: 1,
    borderColor: 'rgba(159, 122, 234, 0.24)',
    borderRadius: 20,
    padding: Platform.OS === 'web' ? 24 : 16,
  },
  formWrapPhone: {
    borderRadius: 16,
    padding: 14,
  },
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: 8,
    borderRadius: 999,
    paddingVertical: 6,
    paddingHorizontal: 12,
    backgroundColor: 'rgba(107, 70, 193, 0.18)',
    marginBottom: 14,
  },
  badgeText: {
    fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
    fontSize: 12,
    fontWeight: '700',
    color: '#D6BCFA',
    letterSpacing: 0.3,
    textTransform: 'uppercase',
  },
  sectionEyebrow: {
    fontFamily:
      Platform.OS === 'web' ? '"JetBrains Mono", ui-monospace, monospace' : undefined,
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 1,
    color: '#6B46C1',
    textTransform: 'uppercase' as const,
    textAlign: 'center' as const,
    marginBottom: 10,
  },
  h2: {
    fontFamily:
      Platform.OS === 'web'
        ? '"Space Grotesk", "Inter", system-ui, sans-serif'
        : undefined,
    fontSize: Platform.OS === 'web' ? 36 : 26,
    fontWeight: '700',
    lineHeight: Platform.OS === 'web' ? 43 : 32,
    letterSpacing: -0.8,
    color: '#FFFFFF',
    marginBottom: 14,
  },
  h2Phone: {
    fontSize: 24,
    lineHeight: 30,
    letterSpacing: -0.5,
  },
  p: {
    fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
    fontSize: 17,
    lineHeight: 26,
    color: 'rgba(255, 255, 255, 0.75)',
    marginBottom: 0,
  },
  pStacked: {
    maxWidth: 620,
  },
  pPhone: {
    fontSize: 15,
    lineHeight: 23,
  },
})
